import Utils from "./utils";
import Verge from 'verge';

/**
 *
 */
class MapFranceGdi {

	/**
	 *
	 * @param options
	 */
	constructor(Bulb){

		Utils.debug('Construct Map GDI');

		this.bulb = Bulb;
		this.$filialesButtons = $('.filiale');
		//console.log(this.$filialesButtons);

		this.init();

	}


	/**
	 * Init
	 */
	init(){
		Utils.debug('Init GDI');

		let self = this;
		self.$filialesButtons.on('mouseenter', function(){
			let deps = $(this).attr('data-dep').split(',');

			if (deps.length < 2 && deps[0] === "*") {
				$('.departement').addClass('active');
			} else {

				// cas spécial pour monaco
				deps.forEach(element => {
					let selector = '.departement.departement' + element;
					$(selector).addClass('active');
				});


			}
		});
		self.$filialesButtons.on('mouseleave', function () {
				$('.departement.active').removeClass('active');
			$('.siege-filiale.Monaco.active').removeClass('active');
		})
	}


}


module.exports = MapFranceGdi;
